<a [routerLink]="['/advertisements', ad().id]">
  <div class="hotspot-image-container">
    <img [alt]="ad().title" [src]="imageUrl().url" class="hotspot-image" />
    @if (imageUrl().isSectorImage) {
      <mat-chip *transloco="let t" class="illustration-image-text">{{ t('SAMPLE_PHOTO') }}</mat-chip>
    }
  </div>
  <app-advertisement-chips [advertisement]="ad()" [categories]="categories()" />
</a>
<div class="hotspot-text-column">
  <img alt="" src="/assets/img/mascot-telescope.svg" />
  <h2 *transloco="let t" class="dynamic-header">{{ t('HOT_SPOT') }}</h2>
  <p class="dynamic-paragraph">{{ ad().title }}</p>
  <a [routerLink]="['/advertisements', ad().id]" class="small-action-button" mat-mini-fab>
    <mat-icon svgIcon="arrow_forward" />
  </a>
</div>
